import { graphql } from "gql";

const EDIT_MESSAGE_SEEN_MUTATION = graphql(`
  mutation EditMessageSeen($id: ID!, $isSeen: Boolean!) {
    editMessage(id: $id, input: { isSeen: $isSeen }) {
      id
      isSeen
    }
  }
`);

export default EDIT_MESSAGE_SEEN_MUTATION;
